import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueBus from 'vue-bus'
import VueUpload from './common/libs/vue-upload';
import './main.less'
import request from './common/request'
import platRequest from './common/plat-request'
import vueQrcode from '@xkeshi/vue-qrcode'
import VueContextMenu from '@xunlei/vue-context-menu'
import business from './components/business-card'
import renderChannel from './components/render-components/render-channel'
import renderPhone from './components/render-components/render-phone'
import renderWechat from './components/render-components/render-wechat'
import renderName from './components/render-components/render-name'
import renderSource from './components/render-components/render-source'
import renderInvite from './view/plugin/report/render-invite'
import renderStaff from './view/home/function/render/render-staff'
import renderLimit from './view/home/function/render/render-limit'

import {
  Button,
  Icon,
  Input,
  Radio,
  Checkbox,
  Switch,
  Table,
  Select,
  Option,
  DatePicker,
  Cascader,
  InputNumber,
  Message,
  Notice,
  Modal,
  Avatar,
  Tooltip,
  Poptip,
  LoadingBar,
  ColorPicker,
  Scroll,
  Spin,
  Row,
  Col,
} from 'iview';
Vue.config.productionTip = false
Vue.component('Button', Button);
Vue.component('ColorPicker', ColorPicker);
Vue.component('Icon', Icon);
Vue.component('Input', Input);
Vue.component('i-Input', Input);
Vue.component('Radio', Radio);
Vue.component('Checkbox', Checkbox);
Vue.component('i-Switch', Switch);
Vue.component('Table', Table);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('DatePicker', DatePicker);
Vue.component('Cascader', Cascader);
Vue.component('InputNumber', InputNumber);
Vue.component('Modal', Modal);
Vue.component('Avatar', Avatar);
Vue.component('Tooltip', Tooltip);
Vue.component('Poptip', Poptip);
Vue.component('vueQrcode', vueQrcode);
Vue.component('Scroll', Scroll);
Vue.component('Spin', Spin);
Vue.component("business",business)
Vue.component("render-channel",renderChannel)
Vue.component("render-phone",renderPhone)
Vue.component("render-wechat",renderWechat)
Vue.component("render-name",renderName)
Vue.component("render-source",renderSource)
Vue.component("render-invite",renderInvite)
Vue.component("render-staff",renderStaff)
Vue.component("render-limit",renderLimit)
Vue.component("Row",Row)
Vue.component("Col",Col)

Vue.prototype.$Loading = LoadingBar;

Message.config({
  top: 24,
  duration: 3
})
Vue.prototype.$Message = Message;
Vue.prototype.$Modal = Modal;
Notice.config({
  top: 64,
  duration: 100
})
Vue.prototype.$Notice = Notice;
Vue.prototype.$http = request;
Vue.prototype.$platHttp = platRequest

Vue.use(VueUpload);
Vue.use(VueContextMenu)
Vue.use(VueBus)

window.vue = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js